var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificationEmailSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.194,
    height: 22.996,
    viewBox: "0 0 33.194 22.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-797.813 -554)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(785.812 549.518)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.312 12.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.847,20.219a.4.4,0,0,1-.273-.109L18.981,15.8a.4.4,0,1,1,.547-.581l4.593,4.309a.4.4,0,0,1-.274.69Z",
    transform: "translate(-8.116 -15.111)",
    fill: "#11526a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8,20.219a.4.4,0,0,1-.274-.69l4.595-4.309a.4.4,0,1,1,.547.581L6.074,20.111A.4.4,0,0,1,5.8,20.219Z",
    transform: "translate(-5.402 -15.112)",
    fill: "#11526a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.76,22.082H2a2,2,0,0,1-2-2V6.478a2,2,0,0,1,2-2H22.76a2,2,0,0,1,2,2V20.086A2,2,0,0,1,22.76,22.082ZM2,5.28a1.2,1.2,0,0,0-1.2,1.2V20.086a1.2,1.2,0,0,0,1.2,1.2H22.76a1.2,1.2,0,0,0,1.2-1.2V6.478a1.2,1.2,0,0,0-1.2-1.2Z",
    transform: "translate(0 0)",
    fill: "#11526a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.511,15.448a2.232,2.232,0,0,1-1.466-.528L.8,5.978a.4.4,0,1,1,.524-.6l10.25,8.941a1.494,1.494,0,0,0,1.882,0L23.688,5.391a.4.4,0,1,1,.525.6L13.976,14.919A2.23,2.23,0,0,1,12.511,15.448Z",
    transform: "translate(-0.133 -0.161)",
    fill: "#11526a"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 6.998,
    cy: 6.998,
    r: 6.998,
    transform: "translate(803.533 563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.761,8.971,0,4.209.966,2.553l3.8,3.726L11.041,0l.966,1.656Z",
    transform: "translate(807 565.442)",
    fill: "#56af56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationEmailSuccess);
export default __webpack_public_path__ + "static/media/icon_notification_email_success.ec9eddfe86e2ff5231e0ff5282f1d20c.svg";
export { ForwardRef as ReactComponent };